<content-panel #panel [itemsCount]="totalCount" [hidden]="docId" [loading]="currentRequest && !currentRequest.closed">
  <ng-template contentPlaceholder>
    <div class="content-state">
      <div class="state-title">{{ 'search-placeholder.smart-search-feature.title' | translate }}</div>
      <div class="state-subtitle">{{ 'search-placeholder.smart-search-feature.subtitle' | translate }}</div>
      <img
        class="state-media cursor-pointer"
        src="assets/images/feature-thumbnail-smart-search.svg"
        alt="smart-search-video"
        (click)="openSmartSearchIntro()"
      />
    </div>
  </ng-template>
  <ng-template contentList [items]="entities" [headerTemplate]="headerTemplate" [itemTemplate]="itemTemplate"> </ng-template>
  <ng-template contentFooter>
    @if (nbPages > 1) {
      <app-pagination [nbPages]="nbPages" [stats]="dataUpdated"></app-pagination>
    }
  </ng-template>
  <ng-template contentLoading>
    <div class="content-loading">
      <ex-overlay-loader direction="column" color="secondary" [text]="'search.loading' | translate"></ex-overlay-loader>
    </div>
  </ng-template>
  <ng-template contentEmpty>
    <div class="content-state">
      <mat-icon svgIcon="close-circle-fill"></mat-icon>
      <div class="state-title">{{ 'content.no-result-message' | translate }}</div>
      <div class="state-subtitle">
        {{ 'content.indicative-no-result-message' | translate }}
      </div>
    </div>
  </ng-template>
</content-panel>
<section [hidden]="!docId">
  <router-outlet></router-outlet>
</section>

<ng-template #headerTemplate>
  <div class="results-header results-header-item">
    <div class="flex-1">
      <div class="results-title">
        {{ (totalCount == 10000 ? 'search.more-than' : '') | translate }}
        {{ totalCount?.toLocaleString() }}
        {{ (totalCount && totalCount > 1 ? 'search.results' : 'search.result') | translate }}
        @if (currentRequest && !currentRequest.closed) {
          <i class="ph-bold ph-circle-notch header-loader"></i>
        }
      </div>
      <div class="results-subtitle">
        {{
          (adminDocsCount > 1 ? 'search.admin-doc-results' : 'search.admin-doc-result')
            | translate: { totalCount: adminDocsCount.toLocaleString() }
        }}
        {{
          (websitesCount > 1 ? 'search.admin-doc-sub-results' : 'search.admin-doc-sub-result')
            | translate: { nbWebsite: websitesCount.toLocaleString() }
        }}
      </div>
    </div>
    <ex-button
      type="ai"
      variant="tonal"
      size="medium"
      class="align-items-center"
      (click)="!smartSearchService.panelOpen() && panel.scrollToTop(); smartSearchService.toggleSmartSearchTrigger()"
      [icon]="smartSearchService.panelOpen() ? 'caret-double-up-bold' : 'caret-double-down-bold'"
      iconPosition="right"
    >
      @if (smartSearchService.panelOpen()) {
        {{ 'search.smart-search-button-close' | translate }}
      } @else {
        {{ 'search.smart-search-button' | translate }}
      }
    </ex-button>
  </div>
  <app-smart-search-panel
    class="results-header-item"
    [searchConfig]="smartSearchService.context()"
    [hidden]="!smartSearchService.panelOpen()"
    [count]="entities.length"
  />
</ng-template>
<ng-template #itemTemplate let-item>
  <app-admin-doc-card
    data-cy="admin-doc-card"
    [bookmarkPaths]="item['bookmark_paths']"
    [docId]="item.id"
    [title]="item.title"
    [publicationDate]="item.publication_date"
    [website]="item.website"
    [nbOccurrences]="item['occurrence_count']"
    [text]="$safeNavigationMigration(item['excerpt']?.[0])"
    [url]="item['url']"
    [displayedPublicationType]="item.displayed_publication_type"
    [matchStems]="item.match_stems"
    [source]="item.source"
    [territories]="item.territories"
    [redirectsToUrl]="item['redirects_to_url']"
    [projectUid]="item.project_uid"
  />
</ng-template>
